/* Daily Nuuds | exit-intent save prompt | production + QA preview | 2026-09-28.prod.1
 * Hooks only mobile builder exit intent. Reuses the existing save/email form.
 * No cart, price, selection, consent or network code is added here.
 */
(function(w,d){
  'use strict';
  if(w.SerranoExitSave)return;
  const VERSION='2026-09-28.prod.1';
  const attached=new WeakSet();
  const bypass=new WeakSet();
  let active=null, status='starting', reason='', timer=0, observer=null, alive=true;

  const saveHost=c=>c?.closeButton?.parentElement?.querySelector?.('[data-dn-save-placement="compact"]');
  const saveButton=c=>saveHost(c)?.shadowRoot?.querySelector?.('button.save');
  const hasSelection=c=>Array.isArray(c?.states)&&c.states.some(s=>Array.isArray(s?.sequence)&&s.sequence.length>0)&&!c.busy&&!c.attempt;
  const saveDialog=()=>[...d.querySelectorAll('[data-dn-save-host]')].map(h=>h.shadowRoot?.querySelector('dialog[open]')).find(Boolean)||null;

  function leave(c, dialog){
    bypass.add(c);
    active=null;
    try{if(dialog?.open)dialog.close();}catch(_){}
    w.setTimeout(()=>{try{c.close();}finally{w.setTimeout(()=>bypass.delete(c),120);}},0);
    status='exited';
  }

  function wireExitButton(button,c,dialog,label){
    if(!button)return;
    button.textContent=label;
    if(button.dataset.dnExitWired==='1')return;
    button.dataset.dnExitWired='1';
    button.addEventListener('click',e=>{
      if(active!==c)return;
      e.preventDefault();e.stopImmediatePropagation();
      leave(c,dialog);
    },true);
  }

  function configure(c){
    if(!alive||active!==c)return;
    const dialog=saveDialog();
    if(!dialog){w.setTimeout(()=>configure(c),30);return;}
    const root=dialog.getRootNode();
    if(dialog.dataset.dnExitCloseWired!=='1'){
      dialog.dataset.dnExitCloseWired='1';
      dialog.addEventListener('close',()=>{if(active===c){active=null;status='builder-active';}});
    }
    const title=root.querySelector('.title');
    const intro=root.querySelector('.intro');
    const benefit=root.querySelector('.benefits p');
    if(title)title.textContent='Gitmeden önce kutunu e-postana bırakalım.';
    if(intro)intro.textContent='Seçimlerin kaybolmasın. E-postana gönder; istediğin zaman aynı kutuya kaldığın yerden dön.';
    if(benefit)benefit.innerHTML='<strong>Tek tıkla geri dön.</strong>Renklerin ve kesimlerin bağlantında hazır kalsın.';
    wireExitButton(root.querySelector('.continue'),c,dialog,'Yine de çık');

    const syncSuccess=()=>{
      if(active!==c||!dialog.open)return;
      const success=root.querySelector('.statusview');
      const back=root.querySelector('.return');
      if(success&&!success.hidden&&back)wireExitButton(back,c,dialog,'Kutudan çık');
      w.requestAnimationFrame(syncSuccess);
    };
    w.requestAnimationFrame(syncSuccess);
    status='exit-form-open';
  }

  function prompt(c,e,why){
    if(!alive||bypass.has(c)||active||!hasSelection(c))return false;
    const button=saveButton(c);
    if(!button||saveHost(c)?.hidden)return false;
    if(e){e.preventDefault();e.stopImmediatePropagation();}
    active=c;reason=why;status='opening-exit-form';
    button.click();
    configure(c);
    return true;
  }

  function attach(c){
    if(!c?.dialog||!c?.closeButton||attached.has(c))return;
    attached.add(c);

    c.closeButton.addEventListener('click',e=>{
      if(bypass.has(c)||!c.dialog.open)return;
      prompt(c,e,'close-button');
    },true);

    c.dialog.addEventListener('cancel',e=>{
      if(bypass.has(c)||!c.dialog.open)return;
      if(prompt(c,e,'back-or-escape'))return;
    },true);

    c.dialog.addEventListener('close',()=>{
      if(active===c)active=null;
      status='builder-closed';
    });
  }

  function scan(){
    if(!alive)return;
    const controllers=w.SerranoMobileBuilder?.controllers;
    if(controllers?.forEach)controllers.forEach(attach);
  }

  function start(){
    const cfg=(()=>{try{return JSON.parse(d.querySelector('[data-dn-save-config]')?.textContent||'{}')}catch(_){return {}}})();
    const role=String(w.Shopify?.theme?.role||cfg.renderedThemeRole||'').toLowerCase();
    const id=String(w.Shopify?.theme?.id||cfg.renderedThemeId||'');
    if(cfg.enabled!==true||cfg.company!=='UCFyTL'||(role==='main'&&cfg.launchApproved!==true)||(role!=='main'&&id!=='166955450456')){status='release-gate-disabled';return;}
    scan();
    observer=new MutationObserver(scan);
    observer.observe(d.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open']});
    timer=w.setInterval(scan,500);
    status='ready';
  }

  w.SerranoExitSave=Object.freeze({
    version:VERSION,
    inspect:()=>({version:VERSION,status,reason,attached:!!w.SerranoMobileBuilder?.controllers?.size,active:!!active}),
    stop:()=>{alive=false;clearInterval(timer);observer?.disconnect();active=null;status='stopped';}
  });
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',start,{once:true});else start();
})(window,document);
